<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 -960 960 960" :width="size + 'px'" fill="currentColor">
    <path d="m600-200-57-56 184-184H80v-80h647L544-704l56-56 280 280-280 280Z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconArrowEast",
  mixins: [ IconBase ],
  props: { ...IconBase.props }
}
</script>